module.exports = __webpack_public_path__ + "img/diji-citizen.4fbbd247.svg";